import { render } from "./ListePartenaire.vue?vue&type=template&id=2306b060&ts=true"
import script from "./ListePartenaire.vue?vue&type=script&lang=ts"
export * from "./ListePartenaire.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__